/* ============================================================================
   RESEÑAS / OPINIONES — motor de la seccion fss-lp-opiniones (landing_page)
   PORTADO de reloj_presidencial_premium/theme-build-v2/assets/rp-reviews.js
   (2026-07-22, pedido del dueño: misma estructura que la pagina del reloj —
   galeria de fotos + lista paginada, alineada a la izquierda en desktop).
   Cambios respecto al original: window.RP_REVIEWS -> window.FSS_REVIEWS y
   [data-reviews] -> [data-fss-reviews] (evita colision de nombres de asset
   con rp-reviews.js, que vive en el MISMO tema compartido). El resto de la
   logica es identica.
   Se omitieron a proposito (no se pidieron esta ronda, JS los ignora si el
   HTML no trae los elementos): filtro por estrellas/foto, orden, y el modal
   de "escribir reseña" — el filtro/orden/modal quedan disponibles para
   agregar despues sin tocar este archivo (los querySelectors ya estan
   guardados con `if`).
   El promedio/conteo (rv-summary) sigue OCULTO por CSS: son opiniones de
   ejemplo y un rating agregado inventado esta prohibido (RULES 7).
   ============================================================================ */
(function () {
  var MAX = 50;

  function fss(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function starsHTML(rating) {
    var full = Math.round(rating || 0), out = '';
    for (var i = 1; i <= 5; i++) out += '<span class="rv-star' + (i <= full ? ' is-on' : '') + '">★</span>';
    return out;
  }
  function perPage() { return window.innerWidth <= 768 ? 3 : 5; }

  /* Avatar: foto del bloque si existe; si no, la inicial del nombre. */
  function avatarHTML(r, initial) {
    if (r.avatar) {
      return '<span class="rv-avatar has-img"><img src="' + fss(r.avatar) + '" alt="" loading="lazy"></span>';
    }
    return '<span class="rv-avatar">' + fss(initial) + '</span>';
  }

  /* ===================== BLOQUE 2: carrusel + lightbox ===================== */
  function buildGallery(state) {
    var wrap = state.root.querySelector('[data-rv-gallery-wrap]');
    var track = state.root.querySelector('[data-rv-gallery]');
    if (!wrap || !track) return;
    if (!state.withImages.length) { wrap.hidden = true; return; }
    wrap.hidden = false;
    /* FIX 3: <=6 fotos -> estatico centrado (sin flechas); >6 -> slider 6/vista */
    wrap.classList.toggle('is-static', state.withImages.length <= 6);
    wrap.classList.toggle('has-slider', state.withImages.length > 6);
    track.innerHTML = state.withImages.map(function (r, i) {
      return '<button type="button" class="rv-gallery-thumb" data-gal-idx="' + i + '" aria-label="Ver imagen de ' + fss(r.name) + '">' +
        '<img src="' + fss(r.image) + '" alt="Reseña de ' + fss(r.name) + '" loading="lazy"></button>';
    }).join('');
    track.querySelectorAll('.rv-gallery-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () { openLightbox(state, parseInt(btn.getAttribute('data-gal-idx'), 10)); });
    });
    var prev = state.root.querySelector('[data-rv-gal-prev]');
    var next = state.root.querySelector('[data-rv-gal-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
  }
  function buildLightbox(state) {
    var lb = state.root.querySelector('[data-rv-lightbox]');
    if (!lb) return;
    state.lb = lb;
    var c = lb.querySelector('[data-rv-lb-close]'), p = lb.querySelector('[data-rv-lb-prev]'), n = lb.querySelector('[data-rv-lb-next]');
    if (c) c.addEventListener('click', function () { closeLightbox(state); });
    if (p) p.addEventListener('click', function () { stepLightbox(state, -1); });
    if (n) n.addEventListener('click', function () { stepLightbox(state, 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLightbox(state); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') closeLightbox(state);
      else if (e.key === 'ArrowLeft') stepLightbox(state, -1);
      else if (e.key === 'ArrowRight') stepLightbox(state, 1);
    });
  }
  function renderLightbox(state) {
    var r = state.withImages[state.lbIdx]; if (!r) return;
    var lb = state.lb, img = lb.querySelector('[data-rv-lb-img]');
    img.src = r.image; img.alt = 'Reseña de ' + r.name;
    lb.querySelector('[data-rv-lb-cap]').innerHTML = '<strong>' + fss(r.name) + '</strong>' + (r.title ? ' · ' + fss(r.title) : '');
    var multi = state.withImages.length > 1;
    lb.querySelector('[data-rv-lb-prev]').style.display = multi ? '' : 'none';
    lb.querySelector('[data-rv-lb-next]').style.display = multi ? '' : 'none';
  }
  function openLightbox(state, idx) {
    if (!state.lb) return;
    state.lbIdx = idx; renderLightbox(state);
    state.lb.hidden = false;
    void state.lb.offsetWidth; // reflow para que la transicion de opacidad dispare
    state.lb.classList.add('is-open');
  }
  function stepLightbox(state, dir) {
    var n = state.withImages.length; if (!n) return;
    state.lbIdx = (state.lbIdx + dir + n) % n; renderLightbox(state);
  }
  function closeLightbox(state) {
    if (!state.lb) return;
    state.lb.classList.remove('is-open');
    setTimeout(function () { state.lb.hidden = true; }, 250);
  }

  /* ===================== BLOQUE 3: lista + paginacion ===================== */
  function pageItems(cur, total) {
    if (total <= 7) { var a = []; for (var i = 1; i <= total; i++) a.push(i); return a; }
    var items = [], start = Math.max(2, cur - 1), end = Math.min(total - 1, cur + 1);
    if (cur <= 3) { start = 2; end = 4; }
    if (cur >= total - 2) { start = total - 3; end = total - 1; }
    items.push(1);
    if (start > 2) items.push('...');
    for (var j = start; j <= end; j++) items.push(j);
    if (end < total - 1) items.push('...');
    items.push(total);
    return items;
  }
  function renderList(state, page) {
    var list = state.root.querySelector('[data-rv-list]');
    if (!list) return;
    var pp = perPage();
    var view = state.view;
    if (!view.length) {
      list.innerHTML = '<p class="rv-empty">No hay reseñas que coincidan con el filtro.</p>';
      var pg0 = state.root.querySelector('[data-rv-pagination]'); if (pg0) pg0.innerHTML = '';
      return;
    }
    var total = Math.max(1, Math.ceil(view.length / pp));
    page = Math.min(Math.max(1, page || state.page || 1), total);
    state.page = page;
    var startI = (page - 1) * pp;
    var slice = view.slice(startI, startI + pp);

    list.innerHTML = slice.map(function (r, i) {
      var initial = (r.name || '?').trim().charAt(0).toUpperCase();
      var imgIdx = r.image ? state.withImages.indexOf(r) : -1;
      return '<article class="rv-card">' +
        '<div class="rv-card-stars">' + starsHTML(r.rating) + '</div>' +
        '<div class="rv-card-head">' +
          avatarHTML(r, initial) +
          '<div class="rv-card-meta">' +
            '<span class="rv-card-name">' + fss(r.name) + (r.verified ? '<span class="rv-verified">Verificado por la tienda</span>' : '') + '</span>' +
            '<span class="rv-card-date">' + fss(r.date || '') + '</span>' +
          '</div>' +
        '</div>' +
        (r.title ? '<h3 class="rv-card-title">' + fss(r.title) + '</h3>' : '') +
        (r.text ? '<p class="rv-card-text">' + fss(r.text) + '</p>' : '') +
        (r.source === 'app' ? '<p class="rv-card-source">Reseña escrita en la App de la Tienda</p>' : '') +
        (r.image ? '<button type="button" class="rv-card-img" data-img-idx="' + imgIdx + '" aria-label="Ampliar imagen"><img src="' + fss(r.image) + '" alt="Foto de ' + fss(r.name) + '" loading="lazy"></button>' : '') +
        '</article>' +
        (i < slice.length - 1 ? '<hr class="rv-sep">' : '');
    }).join('');

    list.querySelectorAll('.rv-card-img').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-img-idx'), 10);
        if (idx >= 0) openLightbox(state, idx);
      });
    });

    renderPagination(state, page, total);
  }
  function renderPagination(state, page, total) {
    var pag = state.root.querySelector('[data-rv-pagination]');
    if (!pag) return;
    if (total <= 1) { pag.innerHTML = ''; return; }
    var html = '<button type="button" class="rv-page-arrow" data-pg="' + (page - 1) + '"' + (page <= 1 ? ' disabled' : '') + ' aria-label="Página anterior">‹</button>';
    html += pageItems(page, total).map(function (it) {
      if (it === '...') return '<span class="rv-page-ellipsis">…</span>';
      return '<button type="button" class="rv-page' + (it === page ? ' is-active' : '') + '" data-pg="' + it + '" aria-label="Página ' + it + '"' + (it === page ? ' aria-current="page"' : '') + '>' + it + '</button>';
    }).join('');
    html += '<button type="button" class="rv-page-arrow" data-pg="' + (page + 1) + '"' + (page >= total ? ' disabled' : '') + ' aria-label="Página siguiente">›</button>';
    pag.innerHTML = html;
    pag.querySelectorAll('[data-pg]').forEach(function (btn) {
      if (btn.hasAttribute('disabled')) return;
      btn.addEventListener('click', function () {
        var p = parseInt(btn.getAttribute('data-pg'), 10);
        if (!isNaN(p)) goToPage(state, p);
      });
    });
  }
  function goToPage(state, p) {
    renderList(state, p);
    var first = state.root.querySelector('.rv-card') || state.root.querySelector('[data-rv-list]');
    if (first) {
      var scroller = document.scrollingElement || document.documentElement;
      var top = first.getBoundingClientRect().top + scroller.scrollTop - 100;
      scroller.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
  }

  /* ===================== BLOQUE 4: modal escribir reseña ===================== */
  function makeRating(container, onChange) {
    if (!container) return { get: function () { return 0; }, set: function () {} };
    container.innerHTML = '';
    var current = 0;
    function paint(n) {
      Array.prototype.forEach.call(container.children, function (b, idx) { b.classList.toggle('on', (idx + 1) <= n); });
    }
    for (var i = 1; i <= 5; i++) {
      (function (v) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'rv-rate-star'; b.textContent = '★';
        b.setAttribute('aria-label', v + ' de 5');
        b.addEventListener('mouseenter', function () { paint(v); });
        b.addEventListener('focus', function () { paint(v); });
        b.addEventListener('click', function () { current = v; paint(v); if (onChange) onChange(v); });
        container.appendChild(b);
      })(i);
    }
    container.addEventListener('mouseleave', function () { paint(current); });
    return { get: function () { return current; }, set: function (v) { current = v; paint(v); } };
  }

  function buildModal(state) {
    var modal = state.root.querySelector('[data-rv-modal]');
    if (!modal) return;
    state.modal = modal; state.modalStep = 1;
    var d = { rating: 0, content: '', email: '', author: '', anon: false, image: null };

    var mainRate = makeRating(modal.querySelector('[data-rv-rate-main]'), function (v) { d.rating = v; goStep(2); });
    makeRating(modal.querySelector('[data-rv-rate-purchase]'), function () {});

    function hideErrors() { modal.querySelectorAll('.rv-error').forEach(function (e) { e.hidden = true; }); }
    function showErr(sel) { var e = modal.querySelector(sel); if (e) e.hidden = false; }
    function goStep(n) {
      modal.querySelectorAll('.rv-step').forEach(function (s) { s.hidden = (parseInt(s.getAttribute('data-rv-step'), 10) !== n); });
      var ind = modal.querySelector('[data-rv-stepind]'); if (ind) ind.textContent = 'Paso ' + n + ' de 5';
      var bar = modal.querySelector('[data-rv-progress]'); if (bar) bar.style.width = (n / 5 * 100) + '%';
      state.modalStep = n;
      if (n === 2) { var ro = modal.querySelector('[data-rv-rate-ro]'); if (ro) ro.innerHTML = starsHTML(d.rating); }
    }
    function open() {
      d.rating = 0; d.content = ''; d.email = ''; d.author = ''; d.anon = false; d.image = null;
      mainRate.set(0);
      var el;
      if ((el = modal.querySelector('[data-rv-content]'))) el.value = '';
      if ((el = modal.querySelector('[data-rv-email]'))) el.value = '';
      if ((el = modal.querySelector('[data-rv-author]'))) el.value = '';
      if ((el = modal.querySelector('[data-rv-anon]'))) el.checked = false;
      if ((el = modal.querySelector('[data-rv-drop-preview]'))) { el.hidden = true; el.src = ''; }
      if ((el = modal.querySelector('[data-rv-drop]'))) el.classList.remove('has-file');
      hideErrors(); goStep(1);
      modal.hidden = false;
      void modal.offsetWidth; // reflow para que la transicion de opacidad dispare
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { modal.hidden = true; }, 250);
    }
    state.openModal = open; state.closeModal = close;

    modal.querySelectorAll('[data-rv-modal-close]').forEach(function (b) { b.addEventListener('click', close); });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (!modal.hidden && e.key === 'Escape') close(); });

    modal.querySelectorAll('[data-rv-back]').forEach(function (b) {
      b.addEventListener('click', function () { goStep(Math.max(1, state.modalStep - 1)); });
    });
    modal.querySelectorAll('[data-rv-next]').forEach(function (b) {
      b.addEventListener('click', function () {
        hideErrors();
        var n = state.modalStep;
        if (n === 2) {
          d.content = (modal.querySelector('[data-rv-content]').value || '').trim();
          if (!d.content) { showErr('[data-rv-err-content]'); return; }
          goStep(3);
        } else if (n === 3) {
          d.email = (modal.querySelector('[data-rv-email]').value || '').trim();
          d.author = (modal.querySelector('[data-rv-author]').value || '').trim();
          d.anon = modal.querySelector('[data-rv-anon]').checked;
          var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.email);
          if (!emailOk || (!d.author && !d.anon)) { showErr('[data-rv-err-author]'); return; }
          goStep(4);
        } else if (n === 4) {
          goStep(5);
        }
      });
    });

    // subir imagen + drag & drop
    var drop = modal.querySelector('[data-rv-drop]');
    var fileInput = modal.querySelector('[data-rv-file]');
    var preview = modal.querySelector('[data-rv-drop-preview]');
    function handleFile(file) {
      if (!file || !/^image\//.test(file.type)) return;
      var url = URL.createObjectURL(file);
      if (preview) { preview.src = url; preview.hidden = false; }
      if (drop) drop.classList.add('has-file');
      d.image = url;
    }
    if (fileInput) fileInput.addEventListener('change', function () { if (fileInput.files && fileInput.files[0]) handleFile(fileInput.files[0]); });
    if (drop) {
      ['dragover', 'dragenter'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('drag'); }); });
      ['dragleave', 'dragend'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('drag'); }); });
      drop.addEventListener('drop', function (e) { e.preventDefault(); drop.classList.remove('drag'); if (e.dataTransfer.files && e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]); });
    }
  }

  /* ===================== BLOQUE 5: filtros y orden (estado base) =====================
     Sin UI en esta version (se omitio el modal/filtro/orden esta ronda), pero
     applyView necesita state.filters/state.sort inicializados para funcionar. */
  /* Acepta DD/MM/AAAA (lo que declara el schema y lo que se PINTA en la
     tarjeta) y tambien AAAA-MM-DD, que es como quedaron escritas las landings
     viejas. Sin la segunda forma devolvia 0 para todas y ordenar por fecha no
     hacia nada: los botones "mas recientes" y "mas antiguas" daban la misma
     lista. */
  function parseDate(s) {
    var t = String(s || '').trim();
    var m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(t);
    if (m) return parseInt(m[3], 10) * 10000 + parseInt(m[2], 10) * 100 + parseInt(m[1], 10);
    m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(t);
    if (m) return parseInt(m[1], 10) * 10000 + parseInt(m[2], 10) * 100 + parseInt(m[3], 10);
    return 0;
  }
  function applyView(state) {
    var f = state.filters || { rating: 0, photo: 'any', verified: 'any' };
    var arr = state.all.filter(function (r) {
      if (f.rating && Math.round(r.rating) !== f.rating) return false;
      if (f.photo === 'with' && !r.image) return false;
      if (f.photo === 'without' && r.image) return false;
      if (f.verified === 'yes' && !r.verified) return false;
      if (f.verified === 'no' && r.verified) return false;
      return true;
    });
    var sort = state.sort || 'recent';
    arr.sort(function (a, b) {
      if (sort === 'high') return (b.rating - a.rating) || (parseDate(b.date) - parseDate(a.date));
      if (sort === 'low') return (a.rating - b.rating) || (parseDate(b.date) - parseDate(a.date));
      if (sort === 'oldest') return parseDate(a.date) - parseDate(b.date);
      return parseDate(b.date) - parseDate(a.date); // recent
    });
    state.view = arr;
    state.page = 1;
    renderList(state, 1);
  }

  /* ===================== BLOQUE 5-bis: filtros y orden (UI) =====================
     Portado de rp-reviews.js buildControls (2026-07-22, pedido del dueño:
     "agrega los filtros"). Silencioso si el HTML no trae los botones. */
  function buildControls(state) {
    var root = state.root;
    state.filters = { rating: 0, photo: 'any', verified: 'any' };
    state.sort = 'recent';
    var fBtn = root.querySelector('[data-rv-filter]'), sBtn = root.querySelector('[data-rv-sort]');
    var fPanel = root.querySelector('[data-rv-filter-panel]'), sPanel = root.querySelector('[data-rv-sort-panel]');

    function closeAll() {
      if (fPanel) fPanel.hidden = true;
      if (sPanel) sPanel.hidden = true;
      if (fBtn) fBtn.classList.remove('is-active');
      if (sBtn) sBtn.classList.remove('is-active');
    }
    state.toggleFilter = function () { var open = fPanel && fPanel.hidden; closeAll(); if (open) { fPanel.hidden = false; fBtn.classList.add('is-active'); } };
    state.toggleSort = function () { var open = sPanel && sPanel.hidden; closeAll(); if (open) { sPanel.hidden = false; sBtn.classList.add('is-active'); } };

    document.addEventListener('click', function (e) {
      if (fPanel && !fPanel.hidden && !fPanel.contains(e.target) && !(fBtn && fBtn.contains(e.target))) { fPanel.hidden = true; if (fBtn) fBtn.classList.remove('is-active'); }
      if (sPanel && !sPanel.hidden && !sPanel.contains(e.target) && !(sBtn && sBtn.contains(e.target))) { sPanel.hidden = true; if (sBtn) sBtn.classList.remove('is-active'); }
    });

    function wireGroup(sel, key, parse) {
      var group = root.querySelector(sel); if (!group) return;
      group.querySelectorAll('.rv-chip').forEach(function (chip) {
        chip.addEventListener('click', function () {
          group.querySelectorAll('.rv-chip').forEach(function (c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
          state.filters[key] = parse(chip.getAttribute('data-val'));
          applyView(state);
        });
      });
    }
    wireGroup('[data-rv-f-rating]', 'rating', function (v) { return parseInt(v, 10); });
    wireGroup('[data-rv-f-photo]', 'photo', function (v) { return v; });

    var clear = root.querySelector('[data-rv-f-clear]');
    if (clear) clear.addEventListener('click', function () {
      state.filters = { rating: 0, photo: 'any', verified: 'any' };
      [['[data-rv-f-rating]', '0'], ['[data-rv-f-photo]', 'any']].forEach(function (p) {
        var g = root.querySelector(p[0]); if (!g) return;
        g.querySelectorAll('.rv-chip').forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-val') === p[1]); });
      });
      applyView(state);
    });

    var sortOpts = root.querySelector('[data-rv-sort-opts]');
    if (sortOpts) sortOpts.querySelectorAll('.rv-sort-opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        sortOpts.querySelectorAll('.rv-sort-opt').forEach(function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        state.sort = opt.getAttribute('data-val');
        applyView(state);
        if (sPanel) { sPanel.hidden = true; if (sBtn) sBtn.classList.remove('is-active'); }
      });
    });
  }

  /* ============================== init ============================== */
  function init() {
    var root = document.querySelector('[data-fss-reviews]');
    if (!root) return;
    var data = (window.FSS_REVIEWS || []).slice(0, MAX);
    var state = {
      root: root, all: data, view: data.slice(),
      withImages: data.filter(function (r) { return r.image; }),
      page: 1, filters: { rating: 0, photo: 'any', verified: 'any' }, sort: 'recent',
      starsHTML: starsHTML, fss: fss,
      renderList: function (p) { renderList(state, p); },
      openLightbox: function (i) { openLightbox(state, i); }
    };
    window.FSS_RV = state;

    // BLOQUE 1: header (resumen oculto por CSS a propósito, RULES 7)
    var avg = data.length ? data.reduce(function (s, r) { return s + (+r.rating || 0); }, 0) / data.length : 0;
    var avgEl = root.querySelector('[data-rv-avg]'), starsEl = root.querySelector('[data-rv-headstars]'), countEl = root.querySelector('[data-rv-count]');
    if (avgEl) avgEl.textContent = (Math.round(avg * 10) / 10).toFixed(1);
    if (starsEl) starsEl.innerHTML = starsHTML(avg);
    if (countEl) countEl.textContent = data.length + ' ' + (data.length === 1 ? 'opinión' : 'opiniones');

    // BLOQUE 2: carrusel + lightbox
    buildLightbox(state);
    buildGallery(state);

    // BLOQUE 5-bis: controles de filtro/orden (definen state.filters y state.sort)
    // BLOQUE 4: modal escribir reseña (decorativo)
    buildModal(state);
    buildControls(state);
    // BLOQUE 3: lista + paginacion (applyView filtra/ordena y renderiza pagina 1)
    applyView(state);
    var lastPP = perPage();
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        var pp = perPage();
        if (pp !== lastPP) { lastPP = pp; renderList(state, 1); }
      }, 150);
    });

    var writeBtn = root.querySelector('[data-rv-write]');

    if (writeBtn) writeBtn.addEventListener('click', function () { if (state.openModal) state.openModal(); });

    var filterBtn = root.querySelector('[data-rv-filter]');
    if (filterBtn) filterBtn.addEventListener('click', function () { if (state.toggleFilter) state.toggleFilter(); });
    var sortBtn = root.querySelector('[data-rv-sort]');
    if (sortBtn) sortBtn.addEventListener('click', function () { if (state.toggleSort) state.toggleSort(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* El PERSONALIZADOR no recarga la pagina: reemplaza el HTML de la seccion por
     AJAX y dispara shopify:section:load. Sin escucharlo, las opiniones quedan
     sin pintar cada vez que el dueno toca un ajuste, y la seccion se ve VACIA
     aunque los bloques esten cargados — el sintoma exacto de "tengo opiniones
     pero no se visualizan". En la tienda publica no hace falta, pero es donde
     se revisa el trabajo, asi que tiene que funcionar ahi tambien. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-fss-reviews]')) init();
  });
})();
